// 一些全局的config配置
const modeUrlObj = {
    // 生产环境
    'production': {
        baseURL: 'https://hzwx.ciccv.cn/ciccv-education',
        authBaseURL: ''
    },
    // 开发环境
    'development': {
        baseURL: '/api',
        authBaseURL: ''
    },
    // 测试环境
    'test': {
        baseURL: 'https://hzwx.ciccv.cn/ciccv-education',//https://testxf.ciccv.cn/ciccv-education https://hzwx.ciccv.cn/ciccv-education
        authBaseURL: ''
    }
}

export default modeUrlObj[process.env.NODE_ENV]